import { Action, Dispatch } from 'redux'
import { fetchBrandsAction } from 'reducks/brand/actions'
import { fetchBrands } from 'repos/brand'

const fetchBrandsOperation = () => {
  return async (dispatch: Dispatch<Action>) => {
    const brands = await fetchBrands()
    dispatch(fetchBrandsAction(brands))
  }
}

export default fetchBrandsOperation
